export default __webpack_public_path__ + "static/media/sunsculpted10.3b7d4e48.jpg";